import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useTenant } from "../hooks/useTenant";
import PageLoader from "../components/Common/PageLoader";

/**
 * PlatformRoute — Guard dedicado para rotas do Painel Administrativo Global.
 *
 * Regras:
 * - Exige autenticação (redireciona para /login se não logado)
 * - Exige role === "super_admin" (redireciona para /home se não for)
 * - NÃO depende de idTenant
 * - NÃO verifica tenantLifecycle (super_admin nunca é bloqueado por lifecycle)
 */
const PlatformRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const { claims, loading: tenantLoading } = useTenant();

    if (loading || (isAuthenticated && tenantLoading)) {
        return <PageLoader />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (claims?.role !== "super_admin") {
        return <Navigate to="/home" replace />;
    }

    return <>{children}</>;
};

export default PlatformRoute;
